export const buttonContainerStyles = {
  marginBottom: '32px',
  height: '40px',
  sx: {
    svg: {
      verticalAlign: 'initial',
    },
    text: {
      fontSize: '13px',
    },
  },
};
